import {combineReducers} from 'redux';
import batch from './batch/reducer';

const Reducers = combineReducers({
    batch
});

export default Reducers